import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLeading } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface AdicionarMensagemRequest {
  idManifestacao: string;
  texto: string;
  onSuccess?: () => void;
  onError?: () => void;
}

interface State {
  isRequesting: boolean;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  errors: []
};

const slice = createSlice({
  name: "ouvidoria.manifestacoes@adicionarMensagem",
  initialState,
  reducers: {
    adicionarMensagem: (
      state,
      _action: PayloadAction<AdicionarMensagemRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    adicionarMensagemSuccess: (state): void => {
      state.isRequesting = false;
    },
    adicionarMensagemFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* worker(params: { type: string; payload: AdicionarMensagemRequest }) {
  const { idManifestacao, texto, onSuccess, onError } = params.payload;
  try {
    yield call(
      api.post,
      `api/v1/cidadao/ouvidoria/manifestacoes/mensagem/${idManifestacao}`,
      {
        texto
      }
    );
    yield put(adicionarMensagemSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(adicionarMensagemFailed(formatError(error)));
    if (onError) onError();
  }
}

export const {
  adicionarMensagem,
  adicionarMensagemSuccess,
  adicionarMensagemFailed
} = slice.actions;
export const { reducer } = slice;
export const saga = takeLeading(adicionarMensagem.type, worker);
